import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { recoverAdminUserService } from '../../services/adminUsersService';

function RecoverAdminUser() {
  const navigate = useNavigate();
  const { code } = useParams();

  useEffect(() => {
    if (code) {
      (async () => {
        await recoverAdminUserService(code);
        navigate('/admin/users');
      })();
    }
  }, [code]);
  return (
    <div />
  );
}

export default RecoverAdminUser;
